import React, { useState } from "react";
import "./Select_reason_heading.css";
import Cancel_Reason_Modal from "../common_modal/cancel_reason_modal/Cancel_Reason_Modal";

function Select_reason_heading({
  setCancelReasonId,
  cancelReasonId,
  setError,
  reason,
  type,
  cancelReasonName,
  setCancelReasonName,
  error,
}) {
  const [showModal, setShowModal] = useState(false);

  const reasonError = error?.reason;

  return (
    <>
      <section
        className="Select_reason_heading theme_bg_primary_colour"
        onClick={() => {
          setShowModal(true);
        }}
        style={{
          border: reasonError ? "1px solid red" : "1px solid transparent",
          borderRadius: "6px",
        }}
      >
        {cancelReasonName ? (
          <h6>{cancelReasonName}</h6>
        ) : (
          <h6>
            {type === "Cancel"
              ? "Select a reason for cancellation >"
              : type === "Return"
              ? "Select a reason for return >"
              : type === "Replace"
              ? "Select a reason for replacement >"
              : ""}
          </h6>
        )}
      </section>

      {reasonError && (
        <p
          style={{
            color: "red",
            fontSize: "14px",
            marginTop: "8px",
            marginBottom: "10px",
          }}
        >
          {reasonError}
        </p>
      )}

      <Cancel_Reason_Modal
        cancelReasonName={cancelReasonName}
        setCancelReasonName={setCancelReasonName}
        setError={setError}
        cancelReasonId={cancelReasonId}
        setCancelReasonId={setCancelReasonId}
        reason={reason}
        modal_title={
          type === "Cancel"
            ? "Select a reason for cancellation "
            : type === "Return"
            ? "Select a reason for return "
            : type === "Replace"
            ? "Select a reason for replacement "
            : ""
        }
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </>
  );
}

export default Select_reason_heading;
